import { ThemeTokens, DARK_THEME } from './theme-config';

// 1. Notion Theme: Muted, editorial, content-first
export const NOTION_THEME: ThemeTokens = {
  '--app-color-primary': '#000000',
  '--app-color-primary-hover': '#2f2f2f',
  '--app-color-background': '#ffffff',
  '--app-color-surface': '#ffffff',
  '--app-color-surface-alt': '#f7f7f5',
  '--app-color-border': '#e2e2e2',
  '--app-color-text': '#37352f',
  '--app-color-text-muted': '#787774',
  '--app-font-sans':
    'ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
  '--app-radius-sm': '3px',
  '--app-radius-md': '3px',
  '--app-radius-lg': '4px',
  '--app-shadow-sm':
    'rgba(15, 15, 15, 0.1) 0px 0px 0px 1px, rgba(15, 15, 15, 0.1) 0px 2px 4px',
};
export const NOTION_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...NOTION_THEME,
  '--app-color-background': '#191919',
  '--app-color-surface': '#191919',
  '--app-color-surface-alt': '#202020',
  '--app-color-primary': '#ffffff',
  '--app-color-text': '#ffffff',
  '--app-color-text-muted': '#9b9a97',
  '--app-color-border': '#2f2f2f',
};

// 2. Linear Theme: Sharp, dense, purple-accented
export const LINEAR_THEME: ThemeTokens = {
  '--app-color-primary': '#5e6ad2',
  '--app-color-primary-hover': '#7175db',
  '--app-color-background': '#ffffff',
  '--app-color-surface': '#f7f8f8',
  '--app-color-surface-alt': '#f1f2f4',
  '--app-color-border': '#e6e8eb',
  '--app-color-text': '#111315',
  '--app-color-text-muted': '#8a8f98',
  '--app-font-sans':
    'Inter, "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  '--app-border-width': '1px',
  '--app-shadow-sm':
    '0 0 0 1px rgba(17, 19, 21, 0.05), 0 1px 2px 0 rgba(17, 19, 21, 0.05)',
  '--app-radius-md': '6px',
};
export const LINEAR_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...LINEAR_THEME,
  '--app-color-background': '#0e0f11',
  '--app-color-surface': '#17181c',
  '--app-color-surface-alt': '#212225',
  '--app-color-border': '#2c2d33',
  '--app-color-text': '#f4f5f5',
  '--app-color-text-muted': '#8a8f98',
  '--app-shadow-sm': '0 4px 6px -1px rgba(0, 0, 0, 0.5)',
};

// 3. Stripe Theme: Polished SaaS, blurple
export const STRIPE_THEME: ThemeTokens = {
  '--app-color-primary': '#635bff',
  '--app-color-primary-hover': '#5850ec',
  '--app-color-background': '#f6f9fc',
  '--app-color-surface': '#ffffff',
  '--app-color-border': '#e3e8ee',
  '--app-color-text': '#1a1f36',
  '--app-color-text-muted': '#4f566b',
  '--app-radius-lg': '8px',
  '--app-shadow-md':
    '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)',
};
export const STRIPE_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...STRIPE_THEME,
  '--app-color-background': '#1a1f36',
  '--app-color-surface': '#2b3149',
  '--app-color-border': '#3c4257',
  '--app-color-text': '#ffffff',
  '--app-color-text-muted': '#a3acb9',
};

// 4. Discord Theme: Rounded, blurple
export const DISCORD_THEME: ThemeTokens = {
  '--app-color-primary': '#5865F2',
  '--app-color-background': '#ffffff',
  '--app-color-surface': '#f7f9fa',
  '--app-color-surface-alt': '#e3e5e8',
  '--app-color-border': '#cccccc',
  '--app-color-text': '#060607',
  '--app-color-text-muted': '#4f545c',
  '--app-font-sans':
    'gg sans, "Noto Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  '--app-radius-md': '8px',
  '--app-radius-lg': '12px',
};
export const DISCORD_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...DISCORD_THEME,
  '--app-color-background': '#313338',
  '--app-color-surface': '#2b2d31',
  '--app-color-surface-alt': '#1e1f22',
  '--app-color-border': '#1e1f22',
  '--app-color-text': '#98a0ff',
  '--app-color-text-muted': '#949ba4',
};

// 5. Retro Terminal
export const RETRO_TERMINAL_THEME: ThemeTokens = {
  '--app-color-primary': '#ffb000',
  '--app-color-background': '#221e00',
  '--app-color-surface': '#332b00',
  '--app-color-border': '#ffb000',
  '--app-color-text': '#ffb000',
  '--app-color-text-muted': '#b37700',
  '--app-font-sans': '"VT323", "Courier New", monospace',
  '--app-font-heading': '"VT323", "Courier New", monospace',
  '--app-shadow-lg': '0 0 10px #ffb000',
  '--app-radius-md': '0px',
  '--app-border-width': '2px',
};
export const RETRO_TERMINAL_DARK_THEME: ThemeTokens = RETRO_TERMINAL_THEME;

// 6. Vaporwave 80s
export const VAPORWAVE_THEME: ThemeTokens = {
  '--app-color-primary': '#ff71ce',
  '--app-color-secondary': '#01cdfe',
  '--app-color-accent': '#05ffa1',
  '--app-color-background': '#b967ff',
  '--app-color-surface': '#fffb96',
  '--app-color-text': '#000000',
  '--app-color-text-muted': '#666666',
  '--app-font-heading': '"Comic Sans MS", "Chalkboard SE", sans-serif',
  '--app-radius-md': '0px',
  '--app-shadow-md': '4px 4px 0 #05ffa1',
};
export const VAPORWAVE_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...VAPORWAVE_THEME,
  '--app-color-background': '#120024',
  '--app-color-surface': '#250048',
  '--app-color-text': '#05ffa1',
  '--app-color-border': '#ff71ce',
  '--app-shadow-md': '4px 4px 0 #ff71ce',
};

// 7. Swiss Grid
export const SWISS_THEME: ThemeTokens = {
  '--app-color-primary': '#d52b1e',
  '--app-color-background': '#f4f4f4',
  '--app-color-surface': '#ffffff',
  '--app-color-border': '#000000',
  '--app-color-text': '#000000',
  '--app-font-sans': '"Helvetica Neue", Helvetica, Arial, sans-serif',
  '--app-font-weight-bold': '700',
  '--app-radius-md': '0px',
  '--app-shadow-md': 'none',
  '--app-border-width': '2px',
};
export const SWISS_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...SWISS_THEME,
  '--app-color-background': '#111111',
  '--app-color-surface': '#000000',
  '--app-color-border': '#ffffff',
  '--app-color-text': '#ffffff',
};

// 8. Memphis
export const MEMPHIS_THEME: ThemeTokens = {
  '--app-color-primary': '#ff3366',
  '--app-color-secondary': '#20d3c2',
  '--app-color-accent': '#ffde17',
  '--app-color-background': '#ffffff',
  '--app-color-surface': '#f4f4f4',
  '--app-color-border': '#000000',
  '--app-radius-lg': '20px',
  '--app-border-width': '3px',
  '--app-shadow-md': '6px 6px 0px #000000',
};
export const MEMPHIS_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...MEMPHIS_THEME,
  '--app-color-background': '#000000',
  '--app-color-surface': '#222222',
  '--app-color-border': '#ffde17',
  '--app-shadow-md': '6px 6px 0px #20d3c2',
  '--app-color-text': '#ffffff',
};

// 9. Editorial
export const EDITORIAL_THEME: ThemeTokens = {
  '--app-color-primary': '#000000',
  '--app-color-background': '#fdfaf6',
  '--app-color-surface': '#ffffff',
  '--app-font-sans': '"Georgia", serif',
  '--app-font-heading': '"Playfair Display", "Georgia", serif',
  '--app-radius-md': '0px',
  '--app-gap': '2rem',
  '--app-spacing': '0.35rem',
  '--app-color-text': '#111111',
};
export const EDITORIAL_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...EDITORIAL_THEME,
  '--app-color-background': '#1c1b1a',
  '--app-color-surface': '#242322',
  '--app-color-text': '#eaddcf',
  '--app-color-primary': '#eaddcf',
};

// 10. Fluent
export const FLUENT_THEME: ThemeTokens = {
  '--app-color-primary': '#0078d4',
  '--app-color-background': '#faf9f8',
  '--app-color-surface': 'rgba(255,255,255,0.7)',
  '--app-surface-blur': '20px',
  '--app-color-border': '#edebe9',
  '--app-radius-md': '4px',
  '--app-font-sans': '"Segoe UI Variable", "Segoe UI", sans-serif',
  '--app-shadow-sm': '0 2px 4px rgba(0,0,0,0.1)',
};
export const FLUENT_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...FLUENT_THEME,
  '--app-color-background': '#201f1e',
  '--app-color-surface': 'rgba(0,0,0,0.6)',
  '--app-color-border': '#323130',
  '--app-color-primary': '#2b88d8',
  '--app-color-text': '#ffffff',
};

// 11. Cupertino
export const CUPERTINO_THEME: ThemeTokens = {
  '--app-color-primary': '#007aff',
  '--app-color-background': '#f2f2f7',
  '--app-color-surface': 'rgba(255,255,255,0.7)',
  '--app-surface-blur': '20px',
  '--app-font-sans': '-apple-system, BlinkMacSystemFont, "SF Pro", sans-serif',
  '--app-radius-lg': '10px',
  '--app-shadow-md': '0 10px 15px -3px rgba(0,0,0,0.1)',
};
export const CUPERTINO_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...CUPERTINO_THEME,
  '--app-color-background': '#000000',
  '--app-color-surface': 'rgba(28,28,30,0.7)',
  '--app-color-primary': '#0a84ff',
  '--app-color-text': '#ffffff',
};

// 12. Carbon
export const CARBON_THEME: ThemeTokens = {
  '--app-color-primary': '#0f62fe',
  '--app-color-background': '#f4f4f4',
  '--app-color-surface': '#ffffff',
  '--app-font-sans': '"IBM Plex Sans", Helvetica, sans-serif',
  '--app-radius-md': '0px',
  '--app-radius-lg': '0px',
  '--app-shadow-md': 'none',
  '--app-border-width': '1px',
};
export const CARBON_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...CARBON_THEME,
  '--app-color-background': '#161616',
  '--app-color-surface': '#262626',
  '--app-color-border': '#393939',
  '--app-color-text': '#f4f4f4',
};

// 13. Ant
export const ANT_THEME: ThemeTokens = {
  '--app-color-primary': '#1677ff',
  '--app-color-background': '#f5f5f5',
  '--app-color-surface': '#ffffff',
  '--app-border-width': '1px',
  '--app-radius-md': '6px',
  '--app-shadow-md':
    '0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)',
};
export const ANT_DARK_THEME: ThemeTokens = {
  ...DARK_THEME,
  ...ANT_THEME,
  '--app-color-background': '#141414',
  '--app-color-surface': '#1f1f1f',
  '--app-color-border': '#424242',
  '--app-color-text': '#ffffff',
};
